/**
 * @generated SignedSource<<b501a2af5d228df43afaaaabde17b407>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TableQuery$variables = {};
export type TableQuery$data = {
  readonly listProducts: ReadonlyArray<{
    readonly _id: string;
    readonly availableQuantity: number;
    readonly barcode: string;
    readonly description: string;
    readonly imageUrl: string;
    readonly name: string;
    readonly price: number;
  }>;
};
export type TableQuery = {
  response: TableQuery$data;
  variables: TableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductModel",
    "kind": "LinkedField",
    "name": "listProducts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "barcode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableQuantity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TableQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TableQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f18f7f5b6285aab426f3939629b687eb",
    "id": null,
    "metadata": {},
    "name": "TableQuery",
    "operationKind": "query",
    "text": "query TableQuery {\n  listProducts {\n    _id\n    name\n    barcode\n    price\n    availableQuantity\n    description\n    imageUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1c8e21dff2f5e6bdf62af75ab527d57";

export default node;
